"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

var _Spinner = _interopRequireDefault(require("@icare/components/lib/Spinner"));

var _Form = _interopRequireDefault(require("@icare/forms/lib/models/Form"));

var _GenericForm = _interopRequireDefault(require("@icare/forms/lib/components/GenericForm"));

var _FormErrorSummary = _interopRequireDefault(require("@icare/forms/lib/components/FormErrorSummary"));

var _LayoutField = _interopRequireDefault(require("@icare/forms/lib/components/LayoutField"));

var _errorMessages = require("../errorMessages");

var _UriUtils = _interopRequireDefault(require("../utils/UriUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var loginEntity = {
  id: "loginForm",
  sections: [{
    id: "loginForm",
    fields: [{
      id: "Username",
      label: "Email address ",
      type: "text",
      size: "l",
      validators: [{
        type: "isEmail"
      }],
      required: true,
      requiredMessage: "Please enter your email address"
    }, {
      id: "Password",
      label: "Password",
      type: "password",
      required: true,
      requiredMessage: "Please enter your password"
    }, {
      id: "AgreeTerms",
      label: "I agree to the terms and conditions",
      type: "checkbox",
      required: true
    }]
  }]
};

/**
 * Okta login form
 */
var LoginForm = /*#__PURE__*/function (_React$Component) {
  _inherits(LoginForm, _React$Component);

  var _super = _createSuper(LoginForm);

  //region Properties
  //endregion
  //region Lifecycle
  function LoginForm(props) {
    var _this;

    _classCallCheck(this, LoginForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_handleSubmit", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        var _this$props, onWillLogin, auth, onSuccess, onError, referrer;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, onWillLogin = _this$props.onWillLogin, auth = _this$props.auth, onSuccess = _this$props.onSuccess, onError = _this$props.onError;
                onWillLogin(values);

                _this.setState({
                  isBusy: true,
                  oktaMessage: null
                });

                referrer = _UriUtils.default.getReferrer();
                values = LoginForm.trimUserName(values);
                _context.prev = 5;
                _context.next = 8;
                return auth.login(values.loginForm__Username, values.loginForm__Password, referrer);

              case 8:
                onSuccess(values.loginForm__Username);
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](5);

                _this._handleLoginError(_context.t0);

                onError(values.loginForm__Username, _this._getOktaErrorMessage(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _this.state = {
      isBusy: false,
      form: _Form.default.initialiseFromConfig(props.onInitilise(props.formConfig || loginEntity)),
      oktaMessage: null
    };
    return _this;
  } //endregion
  //region Methods


  _createClass(LoginForm, [{
    key: "_handleLoginError",
    value: function () {
      var _handleLoginError2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(err) {
        var oktaMessage, _oktaMessage, errCauseSummary;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.props.onLoginError(err); // Check what kind of error we are dealing with here

                if (!(err && (err.errorCode || err.status === 'LOCKED_OUT' || err.status === 'PASSWORD_EXPIRED'))) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 4;
                return this.props.onErrorMessage(err, _errorMessages.FATAL_ERROR);

              case 4:
                oktaMessage = _context2.sent;
                this.setState({
                  isBusy: false,
                  oktaMessage: oktaMessage
                });
                _context2.next = 12;
                break;

              case 8:
                // Okta says you shall not pass ..
                _oktaMessage = {
                  title: err.errorSummary,
                  type: _Message.default.type.ERROR
                }; //default if no errorCauses provided

                errCauseSummary = 'Unable to login';

                if (err.errorCauses && err.errorCauses.length > 0) {
                  _oktaMessage.body = /*#__PURE__*/_react.default.createElement("div", null, err.errorCauses.map(function (summary) {
                    return /*#__PURE__*/_react.default.createElement("p", {
                      key: summary.errorSummary
                    }, summary.errorSummary);
                  }));
                } else {
                  _oktaMessage.body = /*#__PURE__*/_react.default.createElement("p", null, errCauseSummary);
                }

                this.setState({
                  isBusy: false,
                  oktaMessage: _oktaMessage
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _handleLoginError(_x2) {
        return _handleLoginError2.apply(this, arguments);
      }

      return _handleLoginError;
    }()
  }, {
    key: "_getOktaErrorMessage",
    value: function _getOktaErrorMessage(error) {
      if (!error || !error.errorCode) {
        return _errorMessages.FATAL_ERROR.body;
      }

      return error.message;
    }
  }, {
    key: "render",
    //endregion
    //region Render Methods
    value: function render() {
      var _this$props2 = this.props,
          forgotPasswordPlaceholder = _this$props2.forgotPasswordPlaceholder,
          loginButtonText = _this$props2.loginButtonText,
          termsAndConditionsLabel = _this$props2.termsAndConditionsLabel;
      var _this$state = this.state,
          isBusy = _this$state.isBusy,
          form = _this$state.form,
          oktaMessage = _this$state.oktaMessage;
      var optionalTermsProps = {};

      if (termsAndConditionsLabel) {
        optionalTermsProps.label = termsAndConditionsLabel;
      }

      return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        active: isBusy
      }, /*#__PURE__*/_react.default.createElement(_GenericForm.default, {
        form: form,
        onSubmit: this._handleSubmit,
        noTick: true
      }, /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "Username",
        sectionId: "loginForm"
      }), /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "Password",
        sectionId: "loginForm"
      }), forgotPasswordPlaceholder, /*#__PURE__*/_react.default.createElement(_LayoutField.default, _extends({
        form: form,
        fieldId: "AgreeTerms",
        sectionId: "loginForm"
      }, optionalTermsProps)), oktaMessage ? /*#__PURE__*/_react.default.createElement(_Message.default, {
        type: oktaMessage.type,
        title: oktaMessage.title
      }, oktaMessage.body) : /*#__PURE__*/_react.default.createElement(_FormErrorSummary.default, {
        form: form,
        validateAfterSubmit: true
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit",
        disabled: isBusy
      }, loginButtonText)));
    } //endregion

  }]);

  return LoginForm;
}(_react.default.Component);

exports.default = LoginForm;

_defineProperty(LoginForm, "propTypes", {
  auth: _propTypes.default.object.isRequired,

  /**
   * Optional hook event used to modify the form config
   * For example zip with some content
   */
  onInitilise: _propTypes.default.func,

  /**
   * Login error event
   */
  onLoginError: _propTypes.default.func,

  /**
   * A new login attempt event
   */
  onWillLogin: _propTypes.default.func,

  /**
   * Login button text
   */
  loginButtonText: _propTypes.default.string,

  /**
   * Optional place holder for forgot password links
   */
  forgotPasswordPlaceholder: _propTypes.default.node,

  /**
   * optional onSuccess function
   */
  onSuccess: _propTypes.default.func,

  /**
   * optional onError function
   */
  onError: _propTypes.default.func,

  /**
   * optional onError function
   */
  onErrorMessage: _propTypes.default.func,

  /**
   * An external config to override the default form config
   */
  formConfig: _propTypes.default.object,

  /**
   * An override to allow rich text labels
   */
  termsAndConditionsLabel: _propTypes.default.node
});

_defineProperty(LoginForm, "defaultProps", {
  onInitilise: function onInitilise(config) {
    return config;
  },
  loginButtonText: 'Log in',
  forgotPasswordPlaceholder: null,
  onLoginError: function onLoginError() {},
  onWillLogin: function onWillLogin() {},
  onSuccess: function onSuccess() {},
  onError: function onError() {},
  onErrorMessage: function onErrorMessage() {
    return Promise.resolve(_errorMessages.FATAL_ERROR);
  },
  formConfig: null,
  termsAndConditionsLabel: null
});

_defineProperty(LoginForm, "trimFieldValue", function (value) {
  return value.trim();
});

_defineProperty(LoginForm, "trimUserName", function (values) {
  Object.assign({}, values, {
    loginForm__Username: values.loginForm__Username.trim()
  });
  values.loginForm__Username = values.loginForm__Username.trim();
  return values;
});

_defineProperty(LoginForm, "trimUserName", function (values) {
  Object.assign({}, values, {
    loginForm__Username: values.loginForm__Username.trim()
  });
  values.loginForm__Username = values.loginForm__Username.trim();
  return values;
});
//# sourceMappingURL=LoginForm.js.map